<template>
<div class="main">
    <header>{{data.subject}}</header>
    <div class="container">
        <img src="@/assets/imgs/liveerr.png" alt="" srcset="">
    </div>
    <div>
        <button class="btn">进入直播</button>
    </div>
</div>
</template>

<script>
// import Gohome from '@/components/gohome/gohome'
import {
    liveFiestPage
} from '@/model/live/serve'
export default {
    name: 'Live',
    data() {
        return {
            data: {
                subject: '标题'
            }
        }
    },
    components: {
        // Gohome
    },
    created() {
        liveFiestPage({
            liveId: this.$route.query.id
        }).then(res => {
            this.data = res.data
        }).catch(data => {
            if (data.retuCode == 5004) {
                this.$router.push(`/login`)
                return
            }
        })
    },
    methods: {},

}
</script>

<style lang="less" scoped>
header {
    padding: 20px;
    box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.15);
}

.main {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
    background: #fff;
}

.container {
    flex: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.btn {
    padding: 20px;
    width: 100%;
    background: #959595;
    outline: none;
    border: none;
    text-decoration: none;
    color: #fff;
    box-shadow: 5px 3px 7px 3px rgba(0, 0, 0, 0.15);
    font-size: 18px;
}
</style>
